import { UNIDADES } from "@caint/data";
import {
  ApresentacaoCiclo,
  type ApresentacaoCicloProps,
} from "../../components/apresentacao/ApresentacaoCiclo.tsx";
import { PageHeader } from "../ui/kit.tsx";

export type ApresentacaoDesktopProps = ApresentacaoCicloProps;

/** Wrapper desktop da Apresentação do Ciclo. */
export function ApresentacaoDesktop(props: ApresentacaoDesktopProps) {
  const ativa = UNIDADES.find((u) => u.id === props.avaliacaoAtual?.unidadeId);
  return (
    <div className="dk-page" style={{ maxWidth: 1320 }}>
      <div
        className="no-print"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <PageHeader titulo="Apresentação do Ciclo" sub={ativa?.nome ?? "Unidade"} />
        <button type="button" className="m-btn" onClick={() => window.print()}>
          🖨 Imprimir / PDF
        </button>
      </div>
      <ApresentacaoCiclo {...props} />
    </div>
  );
}
